<template>
  <div class="Tutor-Ver">
    <div v-if="data">
      <div>
        <el-form :inline="true" class="search-form">
          <el-form-item label="数据申请-导师审核页面" style="font:20px" align="center">          
          </el-form-item>
        </el-form>
      </div>
      <div class="container" v-if="data">
        <el-form :inline="true" :model="tutorverForm" class="search-form">
          <div class="content-item">
            <div class="content-line">
              学生姓名(Name): <em>{{data.name}}</em>
            </div>
            <div class="content-line">
              邮箱地址(Email): <em>{{data.useremail}}</em>
            </div>
            <div class="content-line">
              所在单位(Organization): <em>{{data.applycop}}</em>
            </div>
          </div>

          <div class="content-item">
            ID: <em>{{data.idai}}</em>
          </div>
          <div class="content-item">
            观测号(Obs ID): <em>{{data.obs_id}}</em>
          </div>
          <div class="content-item">
            观测目标(Target): <em>{{data.target}}</em>
          </div>
          <div class="content-item">
            观测模式(Observe Mode): <em>{{data.obs_mode}}</em>
          </div>
          <div class="content-item">
            观测提案(Proposal ID): <em>{{data.proposal}}</em>
          </div>
          <div class="content-item">
            学生职位(Post): <em>{{data.userposition}}</em>
          </div>
          <div class="content-item">
            数据用途(Purpose): <em>{{data.remark}}</em>
          </div>

          <!-- <el-form-item label="学生姓名(Name):">
            <el-input size="mini" v-model="data.name" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>

          <el-form-item label="邮箱地址(Email)">
            <el-input size="mini" v-model="data.useremail" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>

          <el-form-item label="所在单位(Organization)">
            <el-input size="mini" v-model="data.applycop" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>

          <el-form-item label="ID" >
            <el-input size="mini" v-model="data.idai" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item label="观测号(Obs ID)">
            <el-input size="mini" v-model="data.obs_id" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="观测目标(Target)">
            <el-input size="mini" v-model="data.target" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="观测模式(Observe Mode)">
            <el-input size="mini" v-model="data.obs_mode" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="观测提案(Proposal ID)">
            <el-input size="mini" v-model="data.proposal" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="学生职位(Post)">
            <el-input size="mini" v-model="data.userposition" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="数据用途(Purpose)">
            <el-input size="mini" style="width:500px;" v-model="data.remark" autocomplete="off" :disabled="true"></el-input>
          </el-form-item> -->
          <el-radio-group v-model="data.includeproposal" :disabled="false">
            <el-radio label="1">仅申请此观测数据(Apply this data)</el-radio>
            <el-radio label="2">申请该提案的所有数据(Apply this proposal data)</el-radio>
            <el-radio label="3">申请提案下相同目标天体数据(Apply same target data under this proposal)</el-radio>
          </el-radio-group>
          <el-divider></el-divider>

          <div class="content-item">
            <div class="content-line">
              导师姓名(Tutor name): <em>{{data.tutorname}}</em>
            </div>
            <div class="content-line">
              导师邮箱(Tutor email): <em>{{data.tutoremail}}</em>
            </div>
          </div>

          <!-- <el-form-item label="导师姓名(Tutor name)">
            <el-input size="mini" v-model="data.tutorname" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="导师邮箱(Tutor email)">
            <el-input size="mini" v-model="data.tutoremail" autocomplete="off" :disabled="true"></el-input>
          </el-form-item> -->
          <el-divider>审批信息</el-divider>
          <el-form-item label="审批意见(Approval comments)*">
            <el-input size="mini" v-model="data.tutoropion" autocomplete="off" ></el-input>
          </el-form-item>
      
        </el-form>

        <div  align="right">
          <el-button size="mini" @click="tutorverno" :disabled="verd">拒绝(refuse)</el-button>
          <el-button size="mini" type="primary" @click="tutorverok" :disabled="verd">同意(OK)</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TutorVer',
  props: {
    id: {
      type: String,
      default: '',
    },
    statecode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: null,
      tutorverForm:{
        name: '',
        useremail: '',
        applycop: '',
        userposition:'', 
        id:'',
        obs_id:'',
        target:'',
        obs_mode:'',
        proposal:'',
        includeproposal : '',      
        remark:'',
        tutorname: '',
        tutoremail: '',
        tutoropion: '',
        state_code:'',
        states_list:'',
      },
      verd:false,
    };
  },
  created() {
    this.getData();
    this.getstatecode().then((res) => {
      if(res === 0) {
        this.verd = true;
        alert('此申请已经被其他组长审核！请知悉.(This application has been reviewed by other team leaders! Please be informed)');
      }
    });
  },
 
  methods: {
    getData() {
      const params = {
        id: this.id,
      }
      axios.post('/iapi/userappget', params).then((res) => {
        if (res.data.errcode === 0) {
          this.data = res.data.data;
          // console.log('data',this.data);
        } else {
          this.$message.error('数据不存在');
        }
      });
      
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    getstatecode(){
      const params = {
        id : this.id,
        statecode : this.statecode,
      }
      return axios.post('/iapi/getstatecode', params).then((res) => {
        return res.data.data;
      });
    },
    tutorverok() {
      // console.log('data',this.data);
      if(this.data.tutoropion===null){
        alert('请输入审批意见!');
        return;
      }
      this.verd = true;
      const params = {
        ...this.data,
        ok:'ok',
      }
      // console.log('params --',params);
      axios.post('/iapi/tutor_Ver', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('导师审核完成！');
        }
      });
    },
    tutorverno() {
      if(this.data.tutoropion===null){
        alert('请输入审批意见!');
        return;
      }
      this.verd = true;
      const params = {
        ...this.data,
        ok:'no',
      }
      axios.post('/iapi/tutor_Ver', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('导师审核完成！');
        }
      });
    },

  },
};
</script>

<style scoped lang="scss">

.Tutor-Ver{
  padding: 24px 56px;
  margin:0 auto;
}
.container {
  background: #fff;
  border-radius: 2px;
  
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
.content-line {
  font-size: 14px;
  color: #080808;
  height: 32px;
  line-height: 32px;
  display:inline-block;
  margin-right: 40px;
  em {
    color: #200242;
    font-weight: 600;
    font-style: normal;
    text-decoration: underline;
  }
}
.content-item {
  font-size: 14px;
  color: #080808;
  height: 32px;
  line-height: 32px;
  em {
    color: #200242;
    font-weight: 600;
    font-style: normal;
    text-decoration: underline;
  }
}
</style>
